import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ClipboardList, CheckCircle2, Banknote, Lock, Receipt, Trash2, Undo2, Pencil } from "lucide-react";
import { api } from "@/lib/api";
import { brl, num, fmtDateTime } from "@/lib/format";
import { EmptyState, ErrorState, Loading, Page, PageHeader } from "@/components/kit";

const FIELDS = {
  final_qty: ["Contagem final", ClipboardList], initial_qty: ["Estoque inicial", ClipboardList], purchases_qty: ["Compras", ClipboardList],
  counted: ["Confirmação", CheckCircle2], revenue: ["Faturamento", Banknote], purchase_mode: ["Modo de compras", Pencil],
  status: ["Status", Lock], invoice_added: ["Nota lançada", Receipt], invoice_removed: ["Nota removida", Trash2],
  loss_added: ["Perda registrada", Trash2], purchase_added: ["Compra lançada", Receipt], purchase_removed: ["Compra removida", Undo2], purchase_reduced: ["Compra reduzida", Undo2], count_added: ["Contagem parcial", ClipboardList], count_removed: ["Contagem removida", Undo2], loss_removed: ["Perda removida", Undo2],
};

const show = (field, v) => {
  if (v === null || v === undefined) return "—";
  if (field === "revenue") return brl(v);
  if (field === "counted") return v ? "contado" : "pendente";
  if (typeof v === "number") return num(v);
  return String(v);
};

export default function ConferenceHistory() {
  const { id } = useParams();
  const { data, isLoading, isError, error, refetch } = useQuery({ queryKey: ["history", id], queryFn: () => api(`/conferences/${id}/history`) });
  return (
    <Page narrow>
      <PageHeader title="Histórico de alterações" back={`/conference/${id}`} />
      {isLoading ? <Loading /> : isError ? <ErrorState message={error.message} onRetry={refetch} /> : !data.length ? (
        <EmptyState title="Sem alterações" text="As mudanças de contagem, faturamento e notas aparecerão aqui." />
      ) : (
        <div className="card divide" style={{ padding: 0 }} data-testid="history-list">
          {data.map((h) => {
            const [label, Icon] = FIELDS[h.field] || [h.field, Pencil];
            const single = ["invoice_added", "invoice_removed", "loss_added", "loss_removed", "purchase_added", "purchase_removed", "purchase_reduced", "count_added", "count_removed", "status"].includes(h.field);
            return (
              <div key={h.id} className="flex gap-3 items-start" style={{ padding: "14px var(--pad)" }} data-testid={`history-entry-${h.id}`}>
                <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0" style={{ background: "var(--brand-soft)" }}><Icon size={16} style={{ color: "var(--brand)" }} /></div>
                <div className="flex-1 min-w-0">
                  <div className="label truncate">{label}{h.product_name ? ` · ${h.product_name}` : ""}</div>
                  <div className="text-sm">{single ? show(h.field, h.new ?? h.old) : `${show(h.field, h.old)} → ${show(h.field, h.new)}`}</div>
                  <div className="caption">{h.user_name} · {fmtDateTime(h.created_at)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Page>
  );
}
